import React, { forwardRef } from "react";
import Tooltip from "../../atom/Tooltip";
import clsx from "clsx";

interface SideBarMenuButtonProps {
  tooltipLabel: string;
  onClick?: () => void;
  className?: string;
  children: React.ReactNode;
}

export const SideBarMenuButton = forwardRef<HTMLButtonElement, SideBarMenuButtonProps>(
  ({ onClick, tooltipLabel, className, children }, ref) => {
    return (
      <Tooltip
        content={tooltipLabel}
        className="origin-bottom-center"
      >
        <button
          onClick={onClick}
          ref={ref}
          className={clsx(
            className,
            "flex h-[28px] w-[28px] items-center justify-center rounded-[5px] text-[18px] hover:bg-w-8-hover",
            "transition-colors duration-200"
          )}
        >
          {children}
        </button>
      </Tooltip>
    );
  }
);
